<template>
  <main class="l-main p-register set">
    <div class="l-block">
      <SetLocalNav :hasProject="hasProject" />
      <TitleRegister>
        <Progress :items="progress" />
      </TitleRegister>
      <div class="l-block__content">
        <div class="hTitle">
          <h1>Google Search Consoleを連携します。</h1>
        </div>
        <Loading v-if="isLoading" transparent />
        <template v-else>
          <template v-if="errorResponse">
            <Alert class="l-mt-3"> {{ errorResponse }} </Alert>
            <div class="btnArea">
              <div class="form-auto">
                <Button
                  variant="border"
                  size="w260"
                  fsize="f16"
                  icon="arrow_r"
                  :to="{ name: 'setGSC' }"
                >
                  戻る
                </Button>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="flex">
              <div class="title">
                <p>プロパティ</p>
              </div>
              <div class="form c-alertPos">
                <Select
                  :options="gscSites"
                  :selected="params.gscSiteUrl"
                  :disabled="!gscSites.length"
                  required
                  placeholder="ウェブサイトを選択してください"
                  :class="{ alert: isEdited.gscSiteUrl && error.gscSiteUrl }"
                  @change="changeSite"
                />
                <Alert
                  v-if="isEdited.gscSiteUrl && error.gscSiteUrl"
                  class="l-mt-2"
                >
                  {{ error.gscSiteUrl }}
                </Alert>
              </div>
            </div>
            <Note v-if="isScDomain">
              <p>
                URLプレフィックスプロパティ・ドメインプロパティの詳細については、こちらよりご確認ください。<br /><a
                  href="https://support.google.com/webmasters/answer/34592?hl=ja"
                  target="_blank"
                  >https://support.google.com/webmasters/answer/34592?hl=ja</a
                >
              </p>
            </Note>
            <div class="btnArea">
              <div class="form-auto">
                <Button
                  variant="main"
                  size="w260"
                  fsize="f16"
                  icon="arrow_r"
                  :disabled="isError"
                  @click="submit"
                >
                  連携データの確認をする
                </Button>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
import { ERROR_MESSAGE } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Loading from '@/components/Loading';
import Note from '@/components/Note';
import Progress from '@/components/Progress';
import Select from '@/components/Select';
import SetLocalNav from '@/components/set/SetLocalNav';
import TitleRegister from '@/components/TitleRegister';
import googleSearchConsoleAPI from '@/auth/GoogleSearchConsoleAPI';
import utils from '@/utils';
import Validation from '@/validation';
export default {
  props: ['hasProject'],

  components: {
    Alert,
    Button,
    Loading,
    Note,
    Progress,
    Select,
    SetLocalNav,
    TitleRegister
  },

  data() {
    return {
      data: Object.assign({}, this.$store.state.set.data),
      error: {
        gscSiteUrl: ''
      },
      errorResponse: '',
      googleSearchConsoleAPI,
      params: Object.assign({}, this.$store.state.set.params),
      isEdited: Object.assign({}, this.$store.state.set.isEdited),
      isError: false,
      isLoading: true,
      isScDomain: false,
      progress: [
        {
          label: 'Google Analyticsの登録'
        },
        {
          current: true,
          label: 'Google Search Consoleの登録'
        },
        {
          label: '確認'
        }
      ]
    };
  },

  computed: {
    gscSites() {
      return this.getSelectOptions(this.data.gscSites);
    }
  },

  watch: {
    error: {
      handler() {
        this.checkError();
      },
      deep: true
    },
    'params.gscSiteUrl': {
      handler(value, oldValue) {
        if (utils.isScDomain(this.params.gscSiteUrl)) {
          this.error.gscSiteUrl =
            'ドメインプロパティには対応しておりません。URLプレフィックスプロパティに変更してください';
          this.isScDomain = true;
        } else {
          this.error.gscSiteUrl = new Validation()
            .select()
            .test(this.params.gscSiteUrl);
          this.isScDomain = false;
        }
      },
      immediate: true
    }
  },

  created() {
    this.auth
      .getUserData()
      .then(response => {
        let projects = response.data.user_metadata.projects;
        let gscAccessToken = '';
        for (let i = 0; i < projects.length; i++) {
          if (projects[i].tmpKey === this.params.tmpKey) {
            gscAccessToken = projects[i].gscAccessToken;
            break;
          }
        }
        if (!gscAccessToken) {
          console.error('gsc-0001');
          this.goErrorPage();
          return;
        }
        this.googleSearchConsoleAPI
          .loadClient()
          .then(() => {
            this.googleSearchConsoleAPI.setToken(gscAccessToken);
            this.getGSCSites();
          })
          .catch(error => {
            console.error('gsc-0002', error);
            this.goErrorPage();
          });
      })
      .catch(error => {
        console.error('gsc-0003', error);
        this.goErrorPage();
      });
  },

  methods: {
    checkError() {
      this.isError = utils.checkError(this.error);
    },

    changeSite(value) {
      this.isEdited.gscSiteUrl = true;
      this.params.gscSiteUrl = value;
      this.updateParams();
    },

    getGSCSites() {
      this.googleSearchConsoleAPI
        .getGSCSites()
        .then(response => {
          this.data.gscSites = response;
          this.$store.dispatch('set/setData', this.data);

          if (!this.data.gscSites.length) {
            this.errorResponse = ERROR_MESSAGE.gsc.no_site;
          }
          this.isLoading = false;
        })
        .catch(error => {
          console.error('gsc-0004', error);
          this.goErrorPage();
        });
    },

    getSelectOptions(array) {
      return array.map(item => {
        return {
          label: item.siteUrl,
          value: item.siteUrl
        };
      });
    },

    goErrorPage() {
      this.$router.push({ name: 'setErrorGSC' });
    },

    submit() {
      if (this.isError) {
        return;
      }
      const ga4DataStream = this.data.ga4DataStreams.find(
        item => item.name === this.params.ga4DataStreamId
      );
      // 末尾のスラッシュを取り除いた状態で比較する
      const ga4SiteUrl = this.$options.filters.removeTrailingSlash(
        ga4DataStream.webStreamData.defaultUri
      );
      const gscSiteUrl = this.$options.filters.removeTrailingSlash(
        this.params.gscSiteUrl
      );

      this.$router.push({ name: 'setConfirm' });
    },

    updateParams() {
      this.$store.dispatch('set/setParams', this.params);
      this.$store.dispatch('set/setEdited', this.isEdited);
    }
  }
};
</script>
